import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { parse } from "date-fns";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const AggregatedTHs = React.memo((props) => {
  const { hashRateData } = props;
  const { colors } = useTheme();
  console.log("AggregatedTHs", hashRateData);
  console.log(
    "AggregatedTHs",
    Object.keys(hashRateData).length
  );
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Aggregated THs </H9TitleSmall>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: colors.background.accent,
            borderRadius: "1.5rem",
          }}
        >
          {Object.keys(hashRateData).length > 0 &&
          hashRateData.aggregatedTHsLastHour !==
            undefined ? (
            <>
              <ListItem>
                <ListItemText
                  secondary={
                    !isNaN(
                      parseFloat(
                        hashRateData.aggregatedTHsLastHour
                      )
                    )
                      ? `${parseFloat(
                          hashRateData.aggregatedTHsLastHour
                        ).toFixed(2)} TH/s`
                      : "Invalid data"
                  }
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: colors.text.muted,
                    },
                  }}
                />
              </ListItem>
            </>
          ) : (
            <>
              <ListItem>
                <ListItemText 
                  secondary="Aggregated THs data unavailable"
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: colors.text.muted,
                    },
                  }}
                />
              </ListItem>
            </>
          )}
        </List>
      </>
    </Box>
  );
});
